/* eslint-disable @typescript-eslint/no-explicit-any */
import { IMediaUpload } from '@/interfaces/media';
import {
  IStock,
  ISearchStockReq,
  ISearchStockRes,
  ISearchStockMovementReq,
  ISearchStockMovementRes,
  IImportCoa,
} from '../interfaces/stock';
import * as baseAdapter from './baseAdapter';
// import { IStockReserved } from '@/interfaces/stockReserved';

export const queryStocks = async () => {
  const ret = await baseAdapter.get<IStock[]>('/stock');
  return ret;
};

export const queryStock = async (id: number) => {
  const ret = await baseAdapter.get<IStock>(`/stock/get/${id}`);
  return ret?.data;
};

export const queryPriceSalesStock = async (id: number) => {
  const ret = await baseAdapter.get<IStock[]>(
    `/stock/getPriceSalesStocks?customerId=${id}`,
  );
  return ret;
};

export const searchStocks = async (req: ISearchStockReq) => {
  const ret = await baseAdapter.post<ISearchStockRes>('/stock/gets', req);
  return ret;
};

export const addStock = async (data: Partial<IStock>) => {
  const ret = await baseAdapter.post('/stock/create', data);
  return ret;
};

export const editStock = async (data: Partial<IStock>) => {
  const ret = await baseAdapter.put(`/stock/update/${data.id}`, data);
  return ret;
};

export const deleteStock = async (id: number) => {
  const ret = await baseAdapter.deleteRequest(`/stock/deletestock/${id}`);
  return ret;
};

export const uploadCoa = async (data: Partial<IMediaUpload>) => {
  const ret = await baseAdapter.postForm('/stock/addCoa', data);
  return ret;
};

export const searchStockMovements = async (req: ISearchStockMovementReq) => {
  const ret = await baseAdapter.post<ISearchStockMovementRes>(
    '/stockmovement/gets',
    req,
  );
  return ret;
};

export const importStock = async (data: IStock[]) => {
  const ret = await baseAdapter.post<any>(`/stock/import`, data);
  return ret;
};

export const importStockCoa = async (data: IImportCoa[]) => {
  const ret = await baseAdapter.post<any>(`/stock/importcoa`, data);
  return ret;
};

export const syncStock = async (data: Partial<IStock>) => {
  const ret = await baseAdapter.post(`/stock/sync`, data);
  return ret;
};

// export const addStockReserveds = async (data: Partial<IStockReserved>[]) => {
//   const ret = await baseAdapter.post('/stockReserved/create', data);
//   return ret;
// };

export const deleteStockReserved = async (id: number) => {
  const ret = await baseAdapter.deleteRequest(`/stockReserved/delete/${id}`);
  return ret;
};
